import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { 
    DetailOrgaoComponent,
    FormFuncionarioComponent,
    FormLocaisApresentacaoComponent,
    FormOrgaoComponent,
    FormRegiaoAdminComponent,
    FuncionarioComponent,
    FuncionarioService,
    LocaisApresentacaoComponent,
    LocaisApresentacaoService,
    LocalidadeComponent,
    OrgaoComponent,
    OrgaoService,
    RegiaoAdminComponent,
    RegiaoAdminService,
    ViewOrgaoComponent,
} from '.';

@NgModule({
    declarations: [
        DetailOrgaoComponent,
        FormFuncionarioComponent,
        FormLocaisApresentacaoComponent,
        FormOrgaoComponent,
        FormRegiaoAdminComponent,
        FuncionarioComponent,
        LocaisApresentacaoComponent,
        LocalidadeComponent,
        OrgaoComponent,
        RegiaoAdminComponent,
        ViewOrgaoComponent,
    ],
    imports: [SharedModule],
    providers: [
        FuncionarioService,
        LocaisApresentacaoService,
        OrgaoService,
        RegiaoAdminService
    ]
})
export class LocalidadeModule { }
